const config = {
    apiGateway: {
        REGION: 'eu-central-1',
        URL: 'https://t9eltyxap0.execute-api.eu-central-1.amazonaws.com/prod/graphql/api',
        ESURL: 'https://t9eltyxap0.execute-api.eu-central-1.amazonaws.com/prod/search/api',
    },
    cognito: {
        REGION: 'eu-central-1',
        USER_POOL_ID: 'eu-central-1_8pqzfNhrl',
        APP_CLIENT_ID: '2nmdv24mekr6m7ag6u5efhoieh',
        DOMAIN: 'datahubsandboxeucentral1328627166734.auth.eu-central-1.amazoncognito.com',
        REDIRECT_URI: 'https://datahub-sand.novonordisk.com',
        SIGNOUT_URL: 'https://datahub-sand.novonordisk.com',
        provider: 'CorpAD',
    },
    cloudWatch: {
        APPLICATION_ID: '',
        IDENTITY_POOL_ID: '',
        GUEST_ROLE_ARN: '',
    },
};

const exportedConfig = {
    ...config,
};

export default exportedConfig;
